import {defineStore} from 'pinia';
import axios from "axios";

export const opinionStore = defineStore('opinionStore',{
    state: () => ({
        addArgumentsModalState: false,
        opinionArguments: [],
        currentOpinion: null
    }),
    actions: {
        getOpinionInfoAction(opinionId) {
            return axios.get(`/api/opinions/${opinionId}`)
                .then((resp)=> {
                    this.currentOpinion = resp.data;
                });
        },
        getOpinionsAction(params) {
            return axios.get(`/api/opinions`,{
                params: params
            });
        },
        toggleAddArgumentsModalState() {
            this.addArgumentsModalState = !this.addArgumentsModalState;
        },
        addOpinionArgument(argData) {
            this.opinionArguments.push(argData);
        }
    }
});